
import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, ProvideReactive } from 'vue-property-decorator'

@Component
export default class TesTableRow extends Vue {
  @ProvideReactive()
  @Prop() tesKey!: any

  @ProvideReactive()
  @Prop() grid!: any

  @ProvideReactive()
  @Prop() pageIndex!: any

  @ProvideReactive()
  @Prop() row!: any

  @ProvideReactive()
  @Prop() cols!: any[]

  @ProvideReactive()
  @Prop() colsMap!: any

  @ProvideReactive()
  @Prop() sort!: any

  @ProvideReactive()
  @Prop() rowIndex!: any

  @ProvideReactive()
  @Prop() color!: any

  @ProvideReactive()
  @Prop() dark!: any

  @ProvideReactive()
  @Prop() dense!: any

  @ProvideReactive()
  @Prop() selected!: any

  @ProvideReactive()
  @Prop() __trClass!: string
}
